<style lang="scss">
.hamburger-wrapper {
    display: flex;
    align-items: center;
    cursor: pointer;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                    supported by Chrome, Edge, Opera and Firefox */
}

.hamburger-button {
    width: 14px;
    height: 12px;
    overflow: hidden;
    flex-flow: column;
    justify-content: space-between;
    margin: auto 16px auto 0;
    transition: height 0.2s;
    z-index: 200;
    display: flex;

    span {
        color: #1b1c1f;
        background-color: #1b1c1f;
        height: 2px;
        width: 14px;
        border-radius: 1px;
        display: flex;
        transition: all 0.2s;
        transform-origin: left;
        align-self: flex-end;
    }

    &.active {
        span {
            background-color: #1b1c1f;

            &:nth-child(1) {
                transform: translateX(2px) rotate(45deg);
            }
            &:nth-child(2) {
                opacity: 0;
            }
            &:nth-child(3) {
                transform: translateX(2px) rotate(-45deg);
            }
        }
    }
}
</style>

<template>
    <div class="hamburger-wrapper" @click="toggleMenu">
        <div class="hamburger-button" :class="{'active': active}">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <p :class="textClasses">Menu</p>
    </div>

</template>

<script>
import { bus } from '@/app';

export default {
    name: "Ui.HamburgerButton",

    props: {
        openActive: {
            type: Boolean,
            required: false,
            default: false
        },

        textClasses: {
            type: String,
            required: false,
        }
    },

    data: function () {
        return {
            active: false
        }
    },

    created() {
        if (this.openActive) this.active = true;

        bus.$on('hamburger-close', () => {
            this.active = false;
        });

        bus.$on('hamburger-open', () => {
            this.active = true;
        });
    },

    methods: {
        toggleMenu: function () {
            if (this.active) {
                bus.$emit('hamburger-close');
            } else {
                bus.$emit('hamburger-open');
            }

            this.$root.navigationIsVisble = !this.$root.navigationIsVisble;
        }
    }
}
</script>